import { map, find } from 'ramda';

export const sessionForPage = page => session => page.session._id === session._id;
export const getPageData = (pages, sessions) => map(page => ({
  page,
  session: find(sessionForPage(page), sessions),
}), pages);